<div class="pay-with-points-popup-wrapper">
  <div class="main">
    <div class="header">
      <div class="icon"></div>
      <h4>{{ 'PayWithPoints:PayWithPoints' | translate }}</h4>
      <button (accessibleClick)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <ten-pay-with-points
      [points]="points"
      [fiatAmount]="fiatAmount"
      [fiatCurrency]="fiatCurrency"
      [showDescription]="showDescription"
      [showCurrencyEquivalent]="showCurrencyEquivalent"
    ></ten-pay-with-points>
  </div>
  <p *ngIf="displayNote" class="note">{{ 'PayWithPoints:Mastercard' | translate }}</p>
</div>
